<script setup lang="ts">
// types
import type { SectionReviewStoriesProps } from '@ts-sections/section-review-stories/interfaces'
// hooks
import { useSectionReviewStories } from '@hooks/sections/section-review-stories.hook'
// components
import { SectionLayout } from '@UI/Layouts/SectionLayout'
import BlockReviewStory from '@Blocks/BlockReviewStory.vue'

defineOptions({
  name: 'SectionReviewStories',
})

const props = defineProps<{
  section: SectionReviewStoriesProps
}>()

const {
  refTitle,
  refDescription,
  refBackgroundColor,
} = useSectionReviewStories({
  section: () => props.section,
})
</script>

<template>
  <SectionLayout
    class="section-review-stories"
    :data-component="section.__component"
    :title="refTitle"
    :title-tag="section.layout?.titleTag"
    :description="refDescription"
    :color="refBackgroundColor"
    :space="section.layout?.space"
  >
    <ul class="section-review-stories__stack">
      <li
        v-for="(story, index) in section.stories"
        :key="story.id ?? index"
        class="section-review-stories__story"
      >
        <BlockReviewStory :block="story" />
      </li>
    </ul>
  </SectionLayout>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionReviewStories.scss" />
